import React, {useState, useEffect} from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    TextField,
    Button,
    Stack,
    MenuItem,
    Tooltip,
    Snackbar,
    Alert,
    CircularProgress,
    Box
} from '@mui/material';
import countries from 'i18n-iso-countries';
import geo from 'i18n-iso-countries/langs/ka.json';
import {
    optionsForLegal,
    optionsForPhysical,
    optionsForAssociation,
    optionsForForeigner,
    valuesToDelete,
    optionsForLegalExp,
    optionsForPhysicalExp,
    optionsForAssociationExp,
    optionsForForeignerExp,
    valuesToDeleteExp
} from '../../Constant';
import {MdClose} from 'react-icons/md';
import axios from 'axios';
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import {FaSearch} from "react-icons/fa";
import CustomAlert from "../ConfirmationModal/CustomAlert";

countries.registerLocale(geo);


const countryOptions = Object.entries(
    countries.getNames('ka', {select: 'official'})
).map(([code, name]) => ({code, name}));

const EditInputFields = ({ isExp = false, open, onClose, entity, caseDetails = [], onSave = () => {} }) => {
    const fieldOptionsMap = {
        legal: !isExp ? optionsForLegal : optionsForLegalExp,
        physical: !isExp ? optionsForPhysical : optionsForPhysicalExp,
        association: !isExp ? optionsForAssociation : optionsForAssociationExp,
        foreigner: !isExp ? optionsForForeigner : optionsForForeignerExp,
    };

    const entityKey = String(entity).toLowerCase();
    const availableFields = fieldOptionsMap[entityKey] || [];
    const urlParams = new URLSearchParams(window.location.search);
    const caseId = parseInt(urlParams.get('id'), 10);
    const [isLoadingUserData, setIsLoadingUserData] = useState(false);
    const [loadingOrgData, setLoadingOrgData] = useState(false);
    const [fieldValues, setFieldValues] = useState({});
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    const [alertState, setAlertState] = useState({message: '', severity: 'info'});
    const [isAlertVisible, setIsAlertVisible] = useState(false);
    const [alert, setAlert] = useState({message: "", type: "", show: false});

    const verifyPrivateNumber = async (privateNumber, surname) => {
        setIsLoadingUserData(true);
        setAlertState({message: '', severity: 'error'});
        try {
            const response = await axios.get(
                `https://tcsa.gov.ge/api/GetPhisicalPersonInfo?PrivateNumber=${privateNumber}&LastName=${surname}&SettingEndpointKeyWord=GetPhisicalPersonInfo&ipAddress=234.238.227.129`
            );
            if (response.data?.success && response.data.data?.firstName) {
                setFieldValues(prev => ({
                    ...prev,
                    firstName: {
                        label: 'სახელი',
                        value: response.data.data.firstName
                    }
                }));
                setAlertState({message: 'ოპერაცია წარმატებით დასრულდა!', severity: 'info'});
            } else {
                setAlertState({message: 'პირადი ნომერი ან გვარი არასწორია!', severity: 'error'});
            }
        } catch {
            setAlertState({message: 'დაფიქსირდა შეცდომა', severity: 'error'});
        } finally {
            setIsLoadingUserData(false);
            setIsAlertVisible(true);
        }
    };

    const verifyOrgNumber = async (orgNumber) => {
        setLoadingOrgData(true);
        setAlert({
            message: "",
            type: "error",
            show: false,
        });
        try {


            const response = await axios.get(
                `https://tcsa.gov.ge/api/NAPR_ENREGWS_GetSubjByIdNrQuery?identificationNumber=${orgNumber}&SettingEndpointKeyWord=GetSubjByIdNrQuery&ipAddress=234.238.227.129`
            );
            if (response.data && response.data.success) {
                const orgData = response.data.data;
                if (orgData && orgData.name) {
                    setFieldValues(prev => ({
                        ...prev,
                        ownerName: {
                            label: 'ობიექტის მფლობელის დასახელება',
                            value: orgData.name
                        },
                        ownerLegalAddress: {
                            label: 'ობიექტის მფლობელის იურიდიული მისამართი',
                            value: orgData.address
                        }
                    }));
                } else {
                    setAlert({
                        message: "ორგანიზაციის საიდენთიფიკაციო კოდი არასწორია",
                        type: "error",
                        show: true,
                    });
                    setFieldValues(prev => ({
                        ...prev,
                        ownerName: {
                            label: 'ობიექტის მფლობელის დასახელება',
                            value: ''
                        },
                        ownerLegalAddress: {
                            label: 'ობიექტის მფლობელის იურიდიული მისამართი',
                            value: ''
                        }
                    }));
                }
            } else if (response.data.success === false) {
                setAlert({
                    message: response.data.errors[0]?.message || 'An unknown error occurred',
                    severity: 'error',
                    show: true,
                });
                setFieldValues(prev => ({
                    ...prev,
                    ownerName: {
                        label: 'ობიექტის მფლობელის დასახელება',
                        value: ''
                    },
                    ownerLegalAddress: {
                        label: 'ობიექტის მფლობელის იურიდიული მისამართი',
                        value: ''
                    }
                }))
            } else {
                setAlert({
                    message: "ორგანიზაციის საიდენთიფიკაციო კოდი არასწორია",
                    type: "error",
                    show: true,
                });
                setFieldValues(prev => ({
                    ...prev,
                    ownerName: {
                        label: 'ობიექტის მფლობელის დასახელება',
                        value: ''
                    },
                    ownerLegalAddress: {
                        label: 'ობიექტის მფლობელის იურიდიული მისამართი',
                        value: ''
                    }
                }))
            }
        } catch (error) {
            setAlert({
                message: "ორგანიზაციის საიდენთიფიკაციო კოდი არასწორია",
                type: "error",
                show: true,
            });
            setFieldValues(prev => ({
                ...prev,
                ownerName: {
                    label: 'ობიექტის მფლობელის დასახელება',
                    value: ''
                },
                ownerLegalAddress: {
                    label: 'ობიექტის მფლობელის იურიდიული მისამართი',
                    value: ''
                }
            }))
        } finally {
            setLoadingOrgData(false);
        }
    };


    useEffect(() => {
        if (open) {
            const initialValues = {};
            availableFields.forEach(({name, label}) => {
                initialValues[name] = {label, value: ''};
            });
            setFieldValues(initialValues);
        }
    }, [open, availableFields]);

    const handleFieldChange = ({target: {name, value}}) => {
        const fieldMeta = availableFields.find(f => f.name === name);
        setFieldValues(prev => ({
            ...prev,
            [name]: {
                label: fieldMeta?.label || name,
                value
            }
        }));
    };

    const handleSave = async () => {
        const caseDetailsToDelete = isExp ? valuesToDeleteExp : valuesToDelete;

        const idsToDelete = caseDetails
            .filter(detail => detail.inputType === 3 && caseDetailsToDelete.includes(detail.key))
            .map(detail => detail.id);

        const additions = Object.values(fieldValues).map(({label, value}) => ({
            caseDetailInfo: {
                caseId,
                key: label,
                value,
                inputType: 3,
                dictionaryTypeId: null,
                dictionaryId: null,
                hasDeadline: false,
                hasFile: false,
                unicId: false,
                visibleOnTable: false,
                visibleOnTableForUser: false,
                isIdentificationNumber: false
            }
        }));

        try {
            if (idsToDelete.length) {
                await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/DeleteCaseDetails`,
                    {ids: idsToDelete}
                );
            }
            if (additions.length) {
                await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/AddCaseDetails`,
                    {caseDetails: additions}
                );
            }
        } catch (error) {
            console.error(error);
        } finally {
            onSave();
            onClose(true);
        }
    };

    const areAllFieldsFilled = availableFields.every(({name}) => {
        const value = fieldValues[name]?.value;
        return value !== undefined && value !== '';
    });

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <Box sx={{position: 'relative'}}>
                    <DialogTitle sx={{p: 2}}>
                        <IconButton
                            onClick={onClose}
                            sx={{position: 'absolute', right: 12, top: 8, color: 'text.secondary'}}
                        >
                            <MdClose/>
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        {isLoadingUserData || loadingOrgData && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    bgcolor: 'rgba(255,255,255,0.7)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 10
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        )}
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            align="center"
                            mb={2}
                            color="primary"
                        >
                            განაახლეთ მონაცემები
                        </Typography>

                        <Stack spacing={2}>
                            {availableFields.map(({name, label}) =>
                                name === 'country' ? (
                                    <TextField
                                        key={name}
                                        name={name}
                                        label={label}
                                        select
                                        value={fieldValues[name]?.value || ''}
                                        onChange={handleFieldChange}
                                        fullWidth
                                    >
                                        {countryOptions.map(opt => (
                                            <MenuItem key={opt.code} value={opt.code}>
                                                {opt.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                ) : (
                                    <TextField
                                        key={name}
                                        name={name}
                                        label={label}
                                        value={fieldValues[name]?.value || ''}
                                        onChange={handleFieldChange}
                                        fullWidth
                                        disabled={name === 'firstName' || name === 'ownerName' || name === 'ownerLegalAddress'}
                                    />
                                )
                            )}
                        </Stack>

                        {entityKey === 'physical' && (
                            <Box sx={{mt: 3}}>
                                <Button
                                    disabled={
                                        !fieldValues.lastName?.value ||
                                        !fieldValues.personalNumber?.value
                                    }
                                    endIcon={<FaSearch />}
                                    variant="contained"
                                    onClick={() =>
                                        verifyPrivateNumber(
                                            fieldValues.personalNumber.value,
                                            fieldValues.lastName.value
                                        )
                                    }
                                >
                                    ძიება
                                </Button>
                            </Box>
                        )}

                        {entityKey === 'legal' && (
                            <Box sx={{mt: 3}}>
                                <Button
                                    disabled={
                                        !fieldValues.identificationNumber?.value
                                    }
                                    endIcon={<FaSearch />}
                                    variant="contained"
                                    onClick={() =>
                                        verifyOrgNumber(
                                            fieldValues.identificationNumber.value,
                                        )
                                    }
                                >
                                    ძიება
                                </Button>
                            </Box>
                        )}

                        <Tooltip title={!areAllFieldsFilled ? 'შეავსეთ ყველა ველი!' : ''}>
                            <span>
                                <Button
                                    variant="contained"
                                    sx={{mt: 3}}
                                    disabled={!areAllFieldsFilled}
                                    onClick={() => setIsConfirmationOpen(true)}
                                >
                                    შენახვა
                                </Button>
                            </span>
                        </Tooltip>
                    </DialogContent>
                </Box>
            </Dialog>

            <ConfirmationModal
                isOpen={isConfirmationOpen}
                onRequestClose={() => setIsConfirmationOpen(false)}
                onConfirm={async () => {
                    await handleSave();
                    setIsConfirmationOpen(false);
                }}
            />

            <Snackbar
                open={isAlertVisible}
                autoHideDuration={6000}
                onClose={() => setIsAlertVisible(false)}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            >
                <Alert
                    onClose={() => setIsAlertVisible(false)}
                    severity={alertState.severity}
                    sx={{width: '100%'}}
                >
                    {alertState.message}
                </Alert>
            </Snackbar>
            {alert.show && (
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={() => setAlert({...alert, show: false})}
                />
            )}
        </>
    );
};

export default EditInputFields;
